/** List all crm-sync-related actions such as contacts-and-leads or accounts-and-opportunities prefix searches */
import alt from 'components/Dispatcher';

class CrmSyncActions {
  constructor() {
    this.generateActions(
      'updateCallSyncData',
      'clearSyncCRMFileUploadId',
      // contacts-and-leads-prefix-search actions
      'cancelPrefixSearchContactsAndLeads',
      'prefixSearchContactsAndLeads',
      'prefixSearchContactsAndLeadsLoading',
      'prefixSearchContactsAndLeadsError',
      'prefixSearchContactsAndLeadsSuccess',
      'updateCurrentPrefixSearchContactsAndLeadsValues',
      // Clear the currently selected contact / lead value
      'clearCurrentPrefixSearchContactsAndLeadsValues',
      // Clear the options in the "Contact-and-Leads" search input box
      'clearContactsAndLeadsOptions',
      // account-and-opportunities actions
      'findAccountsAndOpportunitiesByContactName',
      'findAccountsAndOpportunitiesByContactNameLoading',
      'findAccountsAndOpportunitiesByContactNameError',
      'findAccountsAndOpportunitiesByContactNameSuccess',
      // clear the options in the "Related-To" search input box
      'clearAccountsAndOpportunitiesOptions',
      // auto-populate the account value attached to the currently selected contact
      'populateAccountForContact',
      // accounts-and-opportunities prefix search actions
      'cancelPrefixSearchAccountsAndOpportunities',
      'prefixSearchAccountsAndOpportunities',
      'prefixSearchAccountsAndOpportunitiesLoading',
      'prefixSearchAccountsAndOpportunitiesError',
      'prefixSearchAccountsAndOpportunitiesSuccess',
      // update the values inside account-and-opportunities-store
      'updateAccountsAndOpportunitiesValues',
      // clear the values inside account-and-opportunities-store
      'clearAccountsAndOpportunitiesValues',
      // sync the CRM data chosen by the user to the backend
      'syncCrmData',
      'syncCrmDataLoading',
      'syncCrmDataError',
      'syncCrmDataSuccess',
      // obtain metadata about crm-supports-cloud
      'crmSupportsCloud',
      'crmSupportsCloudLoading',
      'crmSupportsCloudError',
      'crmSupportsCloudSuccess',
      // reset CrmSupportsCloudStore.state.get('synced')
      'resetSupportsCloudSynced',
      // contacts-by-account-id actions
      'findContactsByAccountId',
      'findContactsByAccountIdLoading',
      'findContactsByAccountIdError',
      'findContactsByAccountIdSuccess',
      'clearContactsByAccountId',
      // retrieve the card's data after two-way-sync is done
      'fetchCustomContent',
      'fetchCustomContentLoading',
      'fetchCustomContentError',
      'fetchCustomContentSuccess'
    );
  }
}

export default alt.createActions(CrmSyncActions);
